<template>
  <main class="apple-tesla-restaurants">

    <!-- Hero & Search Bar Header -->
    <section class="search-header text-center">
      <b-container>
        <b-row align-h="center" class="justify-content-center">
          <b-col lg="8" md="10">
            <span class="badge-subtle">Experiențe culinare</span>
            <h1 class="page-title">Restaurante &amp; Preparate</h1>
            <p class="page-subtitle">Caută mâncarea ta preferată, un restaurant specific sau explorează categoriile populare.</p>

            <!-- Search Bar Modern -->
            <div class="search-wrapper">
              <div class="search-input-container">
                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>

                <b-input
                    type="text"
                    @keyup.enter="search"
                    v-model="searchTerm"
                    class="custom-search-input"
                    placeholder="Caută categorie, restaurant, oraș..."
                ></b-input>

                <!-- Clear Search Button -->
                <button v-if="searchTerm.length" class="btn-reset-search" type="button" @click="resetSearch" title="Șterge căutarea">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>

                <button @click="search" type="button" class="btn-search-action">
                  Căutare
                </button>
              </div>
            </div>

            <!-- Most Searched Tags (Pill Chips) -->
            <div class="most-searched-container mt-4">
              <span class="most-searched-label">Căutări frecvente:</span>
              <div class="tags-wrapper">
                <button
                    v-for="cat in mostSearched"
                    :key="cat"
                    @click="clickMostSearched(cat)"
                    class="tag-chip"
                    :class="{ active: searchTerm.toLowerCase() === cat.toLowerCase() }"
                    type="button"
                >
                  {{ cat }}
                </button>
              </div>
            </div>

          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- Grid Restaurante -->
    <section class="restaurants-section">
      <b-container>
        <b-row class="cities-restaurants justify-content-center">

          <b-col
              lg="4"
              md="6"
              sm="12"
              v-for="(restaurant, index) in restaurants"
              :key="index"
              class="mb-4"
          >
            <router-link
                class="restaurant-card"
                :to="{ name: 'public.restaurant.details', params: { slug: restaurant.slug } }"
            >
              <div class="card-image-wrapper">
                <b-img :src="restaurant.image_url" fluid class="restaurant-image" :alt="restaurant.name"></b-img>
                <div class="card-overlay"></div>

                <!-- Badges & Status -->
                <div class="badge-stack-top">
                  <span class="status-badge closed-badge" v-if="!restaurant.is_opened">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    Precomandă
                  </span>

                  <span class="status-badge time-badge" v-if="restaurant.is_opened && restaurant.estimated_time">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    {{ restaurant.estimated_time }}
                  </span>

                  <span class="status-badge promo-badge" v-if="restaurant.text_promo">
                    {{ restaurant.text_promo }}
                  </span>
                </div>

                <!-- Info at bottom of card -->
                <div class="card-info">
                  <h3 class="restaurant-title">{{ restaurant.name }}</h3>
                  <p class="restaurant-address">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    {{ restaurant.street }}, {{ restaurant.city }}
                  </p>
                </div>
              </div>
            </router-link>
          </b-col>

          <!-- Mesaj Fără Rezultate -->
          <b-col cols="12" v-if="!isBusy && restaurants.length < 1" class="text-center py-5">
            <div class="empty-state">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>
              <p class="no-results-text mt-3">Nu am găsit niciun rezultat.</p>
              <p class="no-results-sub">Vă rugăm căutați altă categorie de produse, nume de restaurant sau oraș.</p>
            </div>
          </b-col>

        </b-row>

        <!-- Loader infinit -->
        <div v-if="isBusy" class="text-center py-4">
          <span class="loading-spinner"></span>
        </div>
      </b-container>
    </section>

  </main>
</template>

<script>
import PublicCities from '@/components/publicEndpoints/cities'

export default {
  name: 'CityDetails',
  components: {},
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      restaurants: [],
      mostSearched: [
        'pizza', 'paste', 'shaorma', "meniul zilei", 'peste', 'desert', 'burger', 'salate', 'ciorbe'
      ],
      paging: {
        page: 1,
        per_page: 12,
        total: 10,
        lastPage: 100
      },
      filters: {},
      searchTerm: this.$route.params.searchTerm || '',
      lazyLoadingBusy: false,
      endOfResults: false,
      isBusy: false
    }
  },
  methods: {
    resetSearch() {
      this.searchTerm = '';
      this.search();
    },
    clickMostSearched(cat) {
      this.searchTerm = cat;
      this.search();
    },
    search() {
      this.endOfResults = false;
      this.filters = {};
      this.paging.search = this.searchTerm;
      this.paging.page = 1;
      this.paging.lastPage = 1000;
      this.getRestaurants(true);
    },
    getRestaurants(clearResults = false) {
      if (this.endOfResults || this.isBusy) {
        return;
      }
      this.isBusy = true;
      this.paging.search = this.searchTerm;
      PublicCities.get(this.$route.params.slug, this.paging, this.filters).then(response => {
        if (response.data.data.length === 0) {
          this.endOfResults = true;
        }
        if (clearResults) {
          this.restaurants = response.data.data;
        } else {
          response.data.data.forEach(restaurant => {
            if (!this.restaurantExists(restaurant.id)) {
              this.restaurants.push(restaurant);
            }
          });
        }
        this.paging.total = response.data.meta.total;
        this.paging.lastPage = response.data.meta.last_page;
        this.isBusy = false;
        this.lazyLoadingBusy = false;
      }).catch(() => {
        this.isBusy = false;
        this.lazyLoadingBusy = false;
      });
    },
    handleScroll: function(e) {
      if (this.lazyLoadingBusy || this.endOfResults) {
        return;
      }
      const target = e.target.body || document.documentElement;
      const bodyHeight = target.offsetHeight;
      const innerHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const restWrapper = document.querySelector('.cities-restaurants');
      const beforeBottom = restWrapper ? restWrapper.offsetTop : 500;

      if ((innerHeight + scrollY) >= bodyHeight - beforeBottom) {
        this.lazyLoadingBusy = true;
        this.paging.page++;
        this.getRestaurants();
      }
    },
    restaurantExists(id) {
      return this.restaurants.some(el => {
        return el.id === id;
      });
    }
  },
  mounted() {
    this.getRestaurants(true);
  }
}
</script>

<style scoped>
/* Container Principal Apple Light */
.apple-tesla-restaurants {
  padding-top: 100px;
  padding-bottom: 80px;
  background-color: #f5f5f7;
  color: #1d1d1f;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* Header & Search Section */
.search-header {
  margin-bottom: 40px;
}

.badge-subtle {
  display: inline-block;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1.5px;
  font-weight: 600;
  color: #86868b;
  margin-bottom: 12px;
}

.page-title {
  font-size: 2.75rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: #1d1d1f;
  margin-bottom: 12px;
  line-height: 1.1;
}

.page-subtitle {
  font-size: 1.05rem;
  line-height: 1.45;
  color: #515154;
  max-width: 580px;
  margin: 0 auto 28px auto;
  font-weight: 400;
}

/* Search Bar Apple Modern - Center Aligned */
.search-wrapper {
  max-width: 560px;
  margin: 0 auto;
}

.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 980px;
  padding: 6px 6px 6px 18px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
}

.search-input-container:focus-within {
  border-color: #0071e3;
  box-shadow: 0 8px 24px rgba(0, 113, 227, 0.15);
}

.search-icon {
  color: #86868b;
  margin-right: 10px;
  flex-shrink: 0;
  display: block;
}

.custom-search-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 0.95rem !important;
  color: #1d1d1f !important;
  height: 24px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-search-input::placeholder {
  color: #86868b;
  line-height: normal;
}

.btn-reset-search {
  background: none;
  border: none;
  color: #86868b;
  padding: 4px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.btn-reset-search:hover {
  color: #1d1d1f;
  background-color: #e5e5ea;
}

.btn-search-action {
  background-color: #0071e3;
  color: #ffffff;
  border: none;
  border-radius: 980px;
  padding: 10px 22px;
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.btn-search-action:hover {
  background-color: #0077ed;
}

.btn-search-action:active {
  transform: scale(0.97);
}

/* Most Searched Pill Chips */
.most-searched-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.most-searched-label {
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #86868b;
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.tag-chip {
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: #515154;
  padding: 6px 14px;
  border-radius: 980px;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag-chip:hover {
  background-color: #ffffff;
  color: #0071e3;
  border-color: rgba(0, 113, 227, 0.3);
  transform: translateY(-1px);
}

.tag-chip.active {
  background-color: #0071e3;
  color: #ffffff;
  border-color: #0071e3;
}

/* Restaurant Cards Style */
.restaurant-card {
  display: block;
  text-decoration: none !important;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.35s ease;
}

.restaurant-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
}

.card-image-wrapper {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background-color: #e5e5ea;
}

.restaurant-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.restaurant-card:hover .restaurant-image {
  transform: scale(1.05);
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.75) 100%);
}

/* Badges stack in top corner */
.badge-stack-top {
  position: absolute;
  top: 14px;
  left: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 2;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 980px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.closed-badge {
  background-color: rgba(255, 149, 0, 0.9);
  color: #ffffff;
}

.time-badge {
  background-color: rgba(0, 113, 227, 0.88);
  color: #ffffff;
}

.promo-badge {
  background-color: rgba(255, 45, 85, 0.9);
  color: #ffffff;
}

/* Info Text */
.card-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  color: #ffffff;
  z-index: 2;
}

.restaurant-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0 0 4px 0;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.restaurant-address {
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Empty State */
.empty-state {
  color: #86868b;
  padding: 40px 0;
}

.no-results-text {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 4px;
}

.no-results-sub {
  font-size: 0.9rem;
  color: #86868b;
}

/* Loader */
.loading-spinner {
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #0071e3;
  animation: spin 0.8s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
